import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GameSsoCallBackApi from "Apis/GameSsoCallBackApi";
const GameSsoLoginCallBack = (sso_type:string,gameSvcCd:string|null,redirectUri:string|null) => {
    const location= useLocation();
    const navigate = useNavigate();
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }  
    let query =serchParamsFunc();
    let code = query.get("code");
    let naverState = query.get("state");

    useEffect(()=>{
        GameSsoCallBackApi(sso_type,code,naverState,gameSvcCd,redirectUri)
        .then((Resp) => {
            window.opener.SsoRespFunc(Resp.apiHdr.code);
            window.close();
        })
        .catch(() => {
        })
        ;
    },[]);


    return(
        <>
        </>
    )
}

export default GameSsoLoginCallBack;